export default __webpack_public_path__ + "static/patient-forms-c1e10b1911d1f3b49d9d5346c9b91048.pdf";